import axiosInstance from "../../utils/config/config";

export const createCreator = async (userData, creatorData) => {
  try {
    const response = await axiosInstance.post(`/creator/create`, {
      userData,
      creatorData,
    });

    return response.data;
  } catch (error) {
    console.error("Failed to create user", error);
    return null;
  }
};
